import { Col, FlexboxGrid, FormInstance, Row, Text } from 'rsuite';
import PersonDetails, { PersonDetailsProps } from '../PersonDetails';
import React, { forwardRef, useCallback, useState } from 'react';
import { FormValuesPerson } from './utils';
import { FormModelPerson } from 'src/types/person';

interface SingleOwnersFormProps
  extends Pick<
    PersonDetailsProps,
    'disabled' | 'disabledFields' | 'formValues'
  > {
  onChange: (value: FormModelPerson) => void;
  onRemove?: () => void;
  key: string;
  propertyAddress: string;
  showRemove?: boolean;
  title: string;
  disabledFields?: Partial<Record<keyof FormModelPerson, boolean>>;
}

export const SingleOwnersForm = forwardRef<FormInstance, SingleOwnersFormProps>(
  (
    {
      showRemove = false,
      onRemove,
      onChange,
      propertyAddress,
      title,
      formValues,
      key,
      ...rest
    }: SingleOwnersFormProps,
    ref
  ) => {
    const [formErrors, setFormErrors] = useState<Record<string, string>>({});

    const handleSameAsPropertyAddressChanged = useCallback(
      (checked: boolean) => {
        onChange({
          ...formValues,
          sameAsPropertyAddress: checked,
          mailingAddress: checked
            ? propertyAddress || ''
            : formValues.mailingAddress || '',
        });
      },
      [formValues, propertyAddress, onChange]
    );

    return (
      <>
        <Row className="mt-8">
          <Col
            xs={24}
            md={12}
          >
            <FlexboxGrid justify="space-between">
              <Text className="text-bold">{title}</Text>
              {showRemove && (
                <a
                  href="#"
                  onClick={onRemove}
                >
                  Remove owner
                </a>
              )}
            </FlexboxGrid>
          </Col>
        </Row>
        <Row>
          <Col
            xs={24}
            md={12}
          >
            <PersonDetails
              {...rest}
              id={key}
              formError={formErrors}
              formModel={FormValuesPerson}
              formValues={formValues}
              ref={ref}
              setFormError={setFormErrors}
              setFormValues={onChange}
              showSameAsPropertyAddressCheckboxOption
              validationModel={FormValuesPerson}
              onSameAsPropertyAddressChanged={
                handleSameAsPropertyAddressChanged
              }
            />
          </Col>
        </Row>
      </>
    );
  }
);
